/**
 * @generated SignedSource<<5f60d02c7a28a1c92a33e779c4f66dda>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowWithSiblingCreate_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowMaybeWithDragAndDrop_project">;
  readonly " $fragmentType": "RowWithSiblingCreate_project";
};
export type RowWithSiblingCreate_project$key = {
  readonly " $data"?: RowWithSiblingCreate_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowWithSiblingCreate_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowWithSiblingCreate_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RowMaybeWithDragAndDrop_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "4aa0ed8501f38926bbd2f9ec7930aec3";

export default node;
